import { type CSSProperties } from 'react';
import { LEVELS } from '../content/sequence';
import { useGameStore } from '../store/gameStore';
import { isMastered } from '../engine/mastery';

/** Light, kid-facing "reading powers" view: the sequence with mastered patterns lit.
 *  Visible competence (docs/01). The full Royal-Kingdom reward map is Phase 4. */
export function SkillView({ onClose }: { onClose: () => void }) {
  const mastery = useGameStore((s) => s.mastery);
  const band = useGameStore((s) => s.band);

  return (
    <div style={overlay}>
      <div style={header}>
        <span style={title}>🕸️ My Reading Powers</span>
        <button type="button" style={closeBtn} onClick={onClose} aria-label="Close">
          ✕
        </button>
      </div>
      <div style={list}>
        {LEVELS.filter((l) => !l.stub).map((l) => (
          <div key={l.id} style={{ ...levelCard, ...(l.id === band ? levelCurrent : null) }}>
            <div style={levelTitle}>
              {l.title}
              {l.id === band && <span style={badge}>now</span>}
            </div>
            <div style={chips}>
              {l.patterns.map((p) => {
                const st = mastery[p.id];
                const mastered = isMastered(st);
                return (
                  <span key={p.id} style={{ ...chip, ...(mastered ? chipMastered : st ? chipLearning : null) }}>
                    {mastered ? '⭐ ' : ''}
                    {p.label}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const overlay: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 40,
  background: 'var(--frame)',
  display: 'flex',
  flexDirection: 'column',
  padding: 20,
  overflow: 'auto',
};
const header: CSSProperties = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 };
const title: CSSProperties = { fontSize: 28, fontWeight: 800, color: 'var(--gold)' };
const closeBtn: CSSProperties = {
  width: 'var(--target-min)',
  height: 'var(--target-min)',
  borderRadius: '50%',
  border: 'none',
  background: 'var(--frame-2)',
  color: '#f4f4f4',
  fontSize: 24,
  cursor: 'pointer',
};
const list: CSSProperties = { display: 'flex', flexDirection: 'column', gap: 14 };
const levelCard: CSSProperties = {
  background: 'var(--frame-2)',
  borderRadius: 18,
  padding: '14px 18px',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: 'transparent',
};
const levelCurrent: CSSProperties = { borderColor: 'var(--gold)' };
const levelTitle: CSSProperties = { fontSize: 19, fontWeight: 800, color: '#f4f4f4', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 10 };
const badge: CSSProperties = { fontSize: 12, fontWeight: 800, color: 'var(--frame)', background: 'var(--gold)', borderRadius: 999, padding: '2px 10px' };
const chips: CSSProperties = { display: 'flex', flexWrap: 'wrap', gap: 8 };
const chip: CSSProperties = {
  fontFamily: 'var(--font-read)',
  fontWeight: 800,
  fontSize: 18,
  color: '#8ca0c4',
  background: 'var(--frame)',
  borderRadius: 12,
  padding: '6px 14px',
};
const chipLearning: CSSProperties = { color: '#f4f4f4' };
const chipMastered: CSSProperties = { color: 'var(--frame)', background: 'var(--gold)' };
